/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NotificationPreference from './NotificationPreference';

/**
 * The UserNotificationPreferencesPatch model module.
 * @module model/UserNotificationPreferencesPatch
 * @version 1.1.0
 */
class UserNotificationPreferencesPatch {
    /**
     * Constructs a new <code>UserNotificationPreferencesPatch</code>.
     * Partial update; only supplied topics and channels are modified.
     * @alias module:model/UserNotificationPreferencesPatch
     */
    constructor() { 
        
        UserNotificationPreferencesPatch.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserNotificationPreferencesPatch</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserNotificationPreferencesPatch} obj Optional instance to populate.
     * @return {module:model/UserNotificationPreferencesPatch} The populated <code>UserNotificationPreferencesPatch</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserNotificationPreferencesPatch();

            if (data.hasOwnProperty('preferences')) {
                obj['preferences'] = ApiClient.convertToType(data['preferences'], [NotificationPreference]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserNotificationPreferencesPatch</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserNotificationPreferencesPatch</code>.
     */
    static validateJSON(data) {
        if (data['preferences']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['preferences'])) {
                throw new Error("Expected the field `preferences` to be an array in the JSON data but got " + data['preferences']);
            }
            // validate the optional field `preferences` (array)
            for (const item of data['preferences']) {
                NotificationPreference.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Array.<module:model/NotificationPreference>} preferences
 */
UserNotificationPreferencesPatch.prototype['preferences'] = undefined;






export default UserNotificationPreferencesPatch;

